import { css } from 'twin.macro';
import { VscLoading } from 'react-icons/vsc';
import { realEstateListingsApi } from '../../../_services/api/realEstate/listings';
import PropertyCard from '../../RealEstate/PropertyCard';
import PropertyDetail from '../../RealEstate/PropertyDetail';

function RealEstateOverlay({
    showRealEstate,
    onClose,
    selectedListing,
    setSelectedListing,
    reBobConfirm,
    setReBobConfirm,
    confirmReBob,
    filterChips,
    removeReFilter,
    reLoading,
    combinedReListings,
    reLabelFilter,
    setReLabelFilter,
    onSelectListing,
    onOpenChannel,
    onLabelChange,
}) {
    if (!showRealEstate) return null;

    return (
        <div
            css={css`
                position: absolute;
                top: 60px;
                right: 56px;
                background-color: #ffffff;
                width: 420px;
                padding: 0;
                overflow-y: auto;
                border-radius: 6px;
                box-shadow: 0px 15px 35px rgba(0, 0, 0, 0.6);
                max-height: 80vh;
            `}
        >
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '12px 14px 8px',
                    borderBottom: '1px solid #eee',
                    position: 'sticky',
                    top: 0,
                    background: '#fff',
                    zIndex: 1,
                }}
            >
                {selectedListing ? (
                    <div style={{ fontWeight: 700, fontSize: 15 }}>{selectedListing.address || 'Property'}</div>
                ) : (
                    <h2 className="text-dark mb-0" style={{ fontSize: 18, fontWeight: 700 }}>
                        Properties {combinedReListings.length > 0 && `(${combinedReListings.length})`}
                    </h2>
                )}
                <span onClick={onClose} style={{ cursor: 'pointer', fontSize: 18, color: '#999' }}>
                    X
                </span>
            </div>

            {!selectedListing && (reBobConfirm || filterChips.length > 0) && (
                <div style={{ padding: '8px 14px', borderBottom: '1px solid #f0f0f0' }}>
                    {reBobConfirm && (
                        <div
                            style={{
                                marginBottom: 6,
                                padding: '6px 10px',
                                background: '#fff8e1',
                                borderRadius: 4,
                                fontSize: 12,
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <span style={{ color: '#7c6a00' }}>{reBobConfirm.text}</span>
                            <span>
                                <button
                                    onClick={confirmReBob}
                                    className="btn btn-success btn-sm"
                                    style={{ fontSize: 11, padding: '2px 8px', marginRight: 4 }}
                                >
                                    Yes
                                </button>
                                <button
                                    onClick={() => setReBobConfirm(null)}
                                    className="btn btn-outline-secondary btn-sm"
                                    style={{ fontSize: 11, padding: '2px 8px' }}
                                >
                                    No
                                </button>
                            </span>
                        </div>
                    )}
                    {filterChips.length > 0 && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                            {filterChips.map((chip) => (
                                <span
                                    key={chip.key}
                                    className="badge badge-primary"
                                    style={{
                                        fontSize: 11,
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 4,
                                    }}
                                    onClick={() => removeReFilter(chip.key)}
                                >
                                    {chip.label} x
                                </span>
                            ))}
                        </div>
                    )}
                </div>
            )}

            {selectedListing ? (
                <PropertyDetail
                    item={selectedListing}
                    onBack={() => setSelectedListing(null)}
                    onOpenChannel={onOpenChannel}
                />
            ) : reLoading ? (
                <div style={{ padding: 20, textAlign: 'center', color: '#777' }}>
                    <VscLoading className="spin mr-2" /> Loading listings...
                </div>
            ) : combinedReListings.length > 0 ? (
                <>
                    <div
                        style={{
                            display: 'flex',
                            gap: 4,
                            flexWrap: 'wrap',
                            padding: '6px 14px',
                            borderBottom: '1px solid #eee',
                            background: '#fafbfc',
                        }}
                    >
                        <span style={{ fontSize: 11, color: '#777', alignSelf: 'center', marginRight: 4 }}>
                            Filter:
                        </span>
                        <span
                            onClick={() => setReLabelFilter('')}
                            style={{
                                fontSize: 11,
                                cursor: 'pointer',
                                padding: '2px 8px',
                                borderRadius: 10,
                                background: !reLabelFilter ? '#1a73e8' : '#e9ecef',
                                color: !reLabelFilter ? '#fff' : '#555',
                            }}
                        >
                            All
                        </span>
                        {realEstateListingsApi.RE_LABEL_OPTIONS.filter((option) => option.value).map((option) => (
                            <span
                                key={option.value}
                                onClick={() => setReLabelFilter(option.value === reLabelFilter ? '' : option.value)}
                                style={{
                                    fontSize: 11,
                                    cursor: 'pointer',
                                    padding: '2px 8px',
                                    borderRadius: 10,
                                    background:
                                        option.value === reLabelFilter
                                            ? realEstateListingsApi.RE_LABELS[option.value] || '#1a73e8'
                                            : '#e9ecef',
                                    color: option.value === reLabelFilter ? '#fff' : '#555',
                                }}
                            >
                                {option.label}
                            </span>
                        ))}
                    </div>
                    {combinedReListings
                        .filter((item) => !reLabelFilter || item.label === reLabelFilter)
                        .map((item) => (
                            <PropertyCard
                                key={item.id}
                                item={item}
                                selected={selectedListing?.id === item.id}
                                onClick={() => onSelectListing(item)}
                                onOpenChannel={onOpenChannel}
                                onLabelChange={onLabelChange}
                            />
                        ))}
                </>
            ) : (
                <div style={{ padding: 20, color: '#777', textAlign: 'center' }}>
                    No properties found. Try adjusting your search.
                </div>
            )}
        </div>
    );
}

export default RealEstateOverlay;
